import { combineReducers } from 'redux';
import optimist from 'redux-optimist';
import { routerReducer } from 'react-router-redux';
import session from './modules/session';
import password from './modules/password';
import view from './modules/view';

export default optimist(combineReducers({
	routing: routerReducer,
	session,
	password,
	view,
}));



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js